// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2vw_R","headerContainer":"styles_headerContainer__yOhYQ","elementsHeader":"styles_elementsHeader__wDOx8"};